export enum VacancyLossAttrType {
  Gross,
  Unit,
  Turn,
}
